var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPosition(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.715 12.74c1.15 0 2-.848 2-2 0-1.15-.85-2-2-2-1.151 0-2 .85-2 2 0 1.152.848 2 2 2z",
    fill: "gray"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4.74H4c-1.103 0-2 .842-2 1.876v12.25c0 1.034.897 1.875 2 1.875h16c1.103 0 2-.841 2-1.875V6.616c0-1.034-.897-1.875-2-1.875zm0 14l-16-.01V6.74l16 .012V18.74z",
    fill: "gray"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9.74h4v2h-4v-2zm1 4h3v2h-3v-2zm-1.57 2.537c0-1.374-1.676-2.786-3.715-2.786C7.676 13.49 6 14.903 6 16.277v.464h7.43v-.464z",
    fill: "gray"
  })));
}

export default SvgIconPosition;